const getCaptions = (attributes, captionAttributes) => {
    const attributeIds = attributes.map(att => {
        return att.id
    })

    const captions = _.keys(captionAttributes).map(captionId => {
        const caption = captionAttributes[captionId]
        
        if(_.contains(attributeIds, caption.id)) {
            return caption.captionLetter
        }
    })
    
    return _.compact(captions)
}

export default getCaptions